import { call, put, takeLatest } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  DISCLAIMERS_FAILURE,
  DISCLAIMERS_REQUEST,
  DISCLAIMERS_SUCCESS,
} from "../actions/constants";

function* fetchDisclaimers(): any {
  try {
    const result = yield call(ApiService.listAllDisclaimers);
    yield put({ type: DISCLAIMERS_SUCCESS, payload: result });
  } catch (e) {
    yield put({
      type: DISCLAIMERS_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* disclaimersSaga() {
  yield takeLatest(DISCLAIMERS_REQUEST, fetchDisclaimers);
}
